import type { NovaVersaoBody } from "@/modules/financeiro-configuracoes";
import { MSG_PERCENTUAL_INVALIDO, PERCENTUAL_PADRAO } from "./nova-versao-dialog.constants";

const FORMATO = /^-?(\d+([.,]\d{0,4})?|[.,]\d{1,4})$/;

export interface PercentualLido {
  valor: number;
  erro: string | null;
}

export function lerPercentual(texto: string): PercentualLido {
  const limpo = texto.trim();
  if (limpo === "") return { valor: 0, erro: null };
  if (!FORMATO.test(limpo)) return { valor: 0, erro: MSG_PERCENTUAL_INVALIDO };
  const valor = Number(limpo.replace(",", "."));
  if (!Number.isFinite(valor) || valor <= -100) return { valor: 0, erro: MSG_PERCENTUAL_INVALIDO };
  return { valor, erro: null };
}

const FORMATADOR = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
  signDisplay: "exceptZero",
});

export const formatarPercentual = (valor: number): string | null =>
  valor === 0 ? null : FORMATADOR.format(valor);

export const percentualPreenchido = (...textos: string[]): boolean =>
  textos.some((texto) => texto !== PERCENTUAL_PADRAO);

export const montarCorpo = (
  versaoOrigem: string,
  percentualServicos: number,
  percentualMateriais: number,
): NovaVersaoBody => ({ versaoOrigem, percentualServicos, percentualMateriais });

export function descreverCorrecao(servicos: number, materiais: number): string | null {
  const s = formatarPercentual(servicos);
  const m = formatarPercentual(materiais);
  if (s === null && m === null) return null;
  if (s === m) return `${s}% nos custos de Serviços e de Materiais`;
  return [s && `${s}% nos custos de Serviços`, m && `${m}% nos custos de Materiais`]
    .filter(Boolean)
    .join(" e de ");
}
